import retrieveDataFromAPI from "./retrieveDataFromAPI";

const GetCourseById = async (id) => {
  return retrieveDataFromAPI(`/courses/${id}`);
};
export default GetCourseById;
